import {Injectable} from '@angular/core';
import {HttpModelConverter} from "../../../../../core/converter/httpModel.converter";
import {InsoleDataModel} from "./insoleData.model";
import {InsoleDataElementConverter} from "./element/insoleDataElement.converter";
import {LovValueSummaryConverter} from "../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter";
import {InsoleDataSummaryConverter} from "./insoleDataSummary.converter";
@Injectable({
    providedIn: 'root'
})
export class InsoleDataConverter extends HttpModelConverter<InsoleDataModel> {

    constructor(private elementConverter: InsoleDataElementConverter,
                private lovValueSummaryConverter: LovValueSummaryConverter,
                private summaryConverter: InsoleDataSummaryConverter) {
        super();
    }

    protected createInstance(): InsoleDataModel {
        return new InsoleDataModel();
    }

    protected enrichObject(result: InsoleDataModel, src: InsoleDataModel) {
        result.elements = this.elementConverter.convertFromArray(src.elements);
        result.footFrontTwistType = this.lovValueSummaryConverter.convert(src.footFrontTwistType);
        result.footRearTwistType = this.lovValueSummaryConverter.convert(src.footRearTwistType);
        result.summary = this.summaryConverter.convert(src.summary);
    }

}
